import React, { useRef } from "react"; 
import { IoMdSearch } from 'react-icons/io';

const Field = ({value, setValue, placeholder, onFocus, searchIcon=false, onBlur}) => {
  const searchRef = useRef();
  let inputClass = "field-ok"
  if (searchIcon){
    inputClass = "field-ok"
  } else {
    inputClass = "field-ok-no-icon"
  }
  
  return (
    <div className="field-wrapper">
    {searchIcon && <div className="field-icon">
  <IoMdSearch fontSize={21} className="searchIcon" />
  </div>}
  <input
    ref={searchRef}
    type="text"
    onChange={(e) => setValue(e.target.value)}
    placeholder = {placeholder}
    value={value}
    onFocus={() => onFocus()}
    onBlur={() => onBlur()}
    className={inputClass}
  />
</div>
  );

  }

  export default Field;

